var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('PGRowElementSelect',{attrs:{"isEditable":_vm.isEditable,"value":_vm.value,"options":_vm.options},on:{"valueChanged":_vm.valueChanged}})}
var staticRenderFns = []

export { render, staticRenderFns }